const theme = {
	colors: {
		green: '#1DB954',
		white: 'white',
		black: 'black',
		backgroundBlack: 'rgb(18, 18, 18)',
		textGray: '#b3b3b3',
	},
};

export default theme;
export const { colors } = theme;
